// src/data/mockData.ts
import { Person, Project } from '../types';

export const mockPeople: Person[] = [
  {
    id: 'EMP_101',
    name: 'Sarah Chen',
    role: 'Senior Backend Engineer',
    skills: ['Java', 'Spring Boot', 'Microservices', 'AWS', 'Kafka', 'Security'],
    skillLevels: { Java: 9, 'Spring Boot': 9, AWS: 8, Security: 7, Kafka: 6 },
    currentProjectId: 'PROJ_001',
    workload: 85,
    isCriticalPath: true,
    productivityScore: 88,
    tenureMonths: 28,
    careerInterests: ['Architecture', 'Team Leadership'],
    costPerMonth: 15000,
  },
  {
    id: 'EMP_102',
    name: 'Alex Rivera',
    role: 'Machine Learning Engineer',
    skills: ['Python', 'TensorFlow', 'ML', 'Data Engineering', 'AWS'],
    skillLevels: { Python: 9, TensorFlow: 8, ML: 9, 'Data Engineering': 7 },
    currentProjectId: 'PROJ_002',
    workload: 60,
    isCriticalPath: false,
    productivityScore: 92,
    tenureMonths: 18,
    careerInterests: ['Deep Learning', 'Research'],
    costPerMonth: 14000,
  },
  {
    id: 'EMP_103',
    name: 'James Wilson',
    role: 'DevOps Engineer',
    skills: ['AWS', 'Kubernetes', 'Docker', 'Terraform', 'CI/CD'],
    skillLevels: { AWS: 9, Kubernetes: 8, Docker: 9, Terraform: 7 },
    currentProjectId: 'PROJ_003',
    workload: 70,
    isCriticalPath: true,
    productivityScore: 85,
    tenureMonths: 24,
    careerInterests: ['Cloud Architecture', 'SRE'],
    costPerMonth: 13500,
  },
  {
    id: 'EMP_104',
    name: 'Maria Garcia',
    role: 'Full Stack Developer',
    skills: ['React', 'Node.js', 'TypeScript', 'AWS', 'MongoDB'],
    skillLevels: { React: 8, 'Node.js': 9, TypeScript: 8, AWS: 6 },
    currentProjectId: 'PROJ_001',
    workload: 90,
    isCriticalPath: false,
    productivityScore: 78,
    tenureMonths: 12,
    careerInterests: ['Frontend Architecture', 'UX'],
    costPerMonth: 12000,
  },
  {
    id: 'EMP_105',
    name: 'David Kim',
    role: 'Security Engineer',
    skills: ['Security', 'Java', 'AWS', 'Compliance', 'Cryptography'],
    skillLevels: { Security: 9, Java: 7, AWS: 8, Compliance: 9 },
    currentProjectId: 'PROJ_004',
    workload: 65,
    isCriticalPath: true,
    productivityScore: 91,
    tenureMonths: 36,
    careerInterests: ['Security Architecture', 'CTF'],
    costPerMonth: 16000,
  },
];

export const mockProjects: Project[] = [
  {
    id: 'PROJ_001',
    name: 'Payments Platform',
    status: 'yellow',
    healthScore: 65,
    requiredSkills: [
      { skill: 'Java', minLevel: 8, importance: 'critical' },
      { skill: 'AWS', minLevel: 7, importance: 'high' },
      { skill: 'Security', minLevel: 6, importance: 'medium' },
    ],
    dependencies: ['PROJ_003', 'PROJ_005'],
    blockers: ['Waiting on security review', 'Database migration delayed'],
    timelineRisk: 'high',
    budget: 500000,
    budgetUsed: 375000,
    teamMembers: ['EMP_101', 'EMP_104'],
    velocity: 65,
    velocityTrend: 'decreasing',
    revenueImpact: 2500000,
  },
  {
    id: 'PROJ_002',
    name: 'AI Fraud Detection',
    status: 'green',
    healthScore: 85,
    requiredSkills: [
      { skill: 'Python', minLevel: 8, importance: 'critical' },
      { skill: 'ML', minLevel: 8, importance: 'critical' },
      { skill: 'AWS', minLevel: 6, importance: 'medium' },
    ],
    dependencies: ['PROJ_006'],
    blockers: [],
    timelineRisk: 'low',
    budget: 750000,
    budgetUsed: 250000,
    teamMembers: ['EMP_102'],
    velocity: 85,
    velocityTrend: 'increasing',
    revenueImpact: 3500000,
  },
  {
    id: 'PROJ_003',
    name: 'Cloud Migration',
    status: 'red',
    healthScore: 45,
    requiredSkills: [
      { skill: 'AWS', minLevel: 9, importance: 'critical' },
      { skill: 'Kubernetes', minLevel: 8, importance: 'high' },
    ],
    dependencies: [],
    blockers: ['Legacy system compatibility', 'Data migration issues'],
    timelineRisk: 'high',
    budget: 1000000,
    budgetUsed: 850000,
    teamMembers: ['EMP_103'],
    velocity: 40,
    velocityTrend: 'decreasing',
  },
  {
    id: 'PROJ_004',
    name: 'Security Enhancement',
    status: 'green',
    healthScore: 90,
    requiredSkills: [
      { skill: 'Security', minLevel: 9, importance: 'critical' },
      { skill: 'AWS', minLevel: 7, importance: 'high' },
    ],
    dependencies: ['PROJ_001'],
    blockers: [],
    timelineRisk: 'low',
    budget: 300000,
    budgetUsed: 180000,
    teamMembers: ['EMP_105'],
    velocity: 88,
    velocityTrend: 'stable',
  },
];

export const departmentBudgets = {
  engineering: {
    total: 6000000,
    breakdown: {
      salaries: 4200000,
      tools: 800000,
      cloud: 600000,
      training: 250000,
      vendor: 150000,
    },
  },
  product: {
    total: 1500000,
    breakdown: {
      salaries: 1100000,
      tools: 250000,
      research: 150000,
    },
  },
  marketing: {
    total: 1200000,
    breakdown: {
      salaries: 800000,
      advertising: 300000,
      events: 100000,
    },
  },
};
